import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';


import { NAV, HEADER } from './config-layout';
import { useResponsive } from '../../hooks/use-responsive';

// ----------------------------------------------------------------------

const SPACING = 8;

export default function Main({ children, sx, ...other }) {
  const lgUp = useResponsive('up', 'lg');

  return (
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        flexDirection: 'column',
        py: `${HEADER.H_MOBILE + SPACING}px`,
        ...(lgUp && {
          px: 2,
          py: `${HEADER.H_DESKTOP + SPACING}px`,
          width: `calc(100% - ${NAV.WIDTH}px)`,
        }),
        ...sx,
      }}
      {...other}
    >
      {children}
      <Box component="footer" sx={{ mt: 'auto', pt: 4, textAlign: 'center' }}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ whiteSpace: { xs: 'normal', sm: 'nowrap' } }}
        >
          © 2026 HamsaLomi Association. All rights reserved. Powered by{' '}
          <a
            href="https://solutions.adacloudtech.com/"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'inherit' }}
          >
            ADACloudTech Solutions
          </a>
        </Typography>
      </Box>
    </Box>
  );
}

Main.propTypes = {
  children: PropTypes.node,
  sx: PropTypes.object,
};
